/* ==========================================================================
   Be Smart International — Global Theme JS
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Logo → home ---------- */
  document.querySelectorAll('.logo').forEach(function (el) {
    el.addEventListener('click', function () {
      window.location.href = window.theme.routes.root;
    });
  });

  /* ---------- Mobile filter toggle (collection page) ---------- */
  var filterBtn = document.getElementById('mobileFilterBtn');
  if (filterBtn) {
    filterBtn.addEventListener('click', function () {
      document.getElementById('filterSidebar').classList.toggle('open');
    });
  }

  /* ---------- Product gallery thumbs + arrows + lightbox ---------- */
  var galleryThumbs = Array.prototype.slice.call(document.querySelectorAll('.gallery-thumb'));
  var galleryIndex = Math.max(0, galleryThumbs.findIndex(function (thumb) { return thumb.classList.contains('active'); }));
  var galleryMainImg = document.getElementById('mainGalleryImg');
  var galleryLightbox = document.querySelector('[data-gallery-lightbox]');
  var galleryLightboxImg = document.querySelector('[data-gallery-lightbox-img]');
  var galleryZoomTrigger = document.querySelector('[data-gallery-zoom]');

  function galleryHighRes(url) {
    return (url || '').replace(/([?&]width=)\d+/, '$1' + '2400');
  }

  function syncLightboxImage() {
    if (!galleryLightboxImg || !galleryMainImg) return;
    var activeThumb = galleryThumbs[galleryIndex] && galleryThumbs[galleryIndex].querySelector('img');
    var source = activeThumb ? (activeThumb.dataset.full || activeThumb.src) : galleryMainImg.src;
    galleryLightboxImg.src = galleryHighRes(source);
    galleryLightboxImg.alt = galleryMainImg.alt;
  }

  function showGalleryImage(index) {
    if (!galleryThumbs.length) return;
    galleryIndex = (index + galleryThumbs.length) % galleryThumbs.length;
    galleryThumbs.forEach(function (thumb, i) { thumb.classList.toggle('active', i === galleryIndex); });
    var activeThumbImg = galleryThumbs[galleryIndex].querySelector('img');
    if (galleryMainImg && activeThumbImg) {
      galleryMainImg.src = activeThumbImg.dataset.full || activeThumbImg.src;
      if (activeThumbImg.dataset.srcset) galleryMainImg.srcset = activeThumbImg.dataset.srcset;
      galleryMainImg.alt = activeThumbImg.alt;
    }
    if (galleryLightbox && galleryLightbox.classList.contains('is-open')) syncLightboxImage();
  }

  function openGalleryLightbox() {
    if (!galleryLightbox || !galleryMainImg) return;
    syncLightboxImage();
    galleryLightbox.classList.add('is-open');
    galleryLightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('gallery-lightbox-open');
    var closeButton = galleryLightbox.querySelector('[data-gallery-close]');
    if (closeButton) closeButton.focus();
  }

  function closeGalleryLightbox() {
    if (!galleryLightbox) return;
    galleryLightbox.classList.remove('is-open');
    galleryLightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('gallery-lightbox-open');
    if (galleryZoomTrigger) galleryZoomTrigger.focus();
  }

  galleryThumbs.forEach(function (thumb, index) {
    thumb.addEventListener('click', function () { showGalleryImage(index); });
  });

  var galleryPrev = document.querySelector('[data-gallery-prev]');
  var galleryNext = document.querySelector('[data-gallery-next]');
  if (galleryPrev) galleryPrev.addEventListener('click', function () { showGalleryImage(galleryIndex - 1); });
  if (galleryNext) galleryNext.addEventListener('click', function () { showGalleryImage(galleryIndex + 1); });

  if (galleryZoomTrigger) {
    galleryZoomTrigger.addEventListener('click', openGalleryLightbox);
    galleryZoomTrigger.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); openGalleryLightbox(); }
    });
  }
  if (galleryLightbox) {
    var closeButton = galleryLightbox.querySelector('[data-gallery-close]');
    var lightboxPrev = galleryLightbox.querySelector('[data-lightbox-prev]');
    var lightboxNext = galleryLightbox.querySelector('[data-lightbox-next]');
    if (closeButton) closeButton.addEventListener('click', closeGalleryLightbox);
    if (lightboxPrev) lightboxPrev.addEventListener('click', function () { showGalleryImage(galleryIndex - 1); });
    if (lightboxNext) lightboxNext.addEventListener('click', function () { showGalleryImage(galleryIndex + 1); });
    galleryLightbox.addEventListener('click', function (event) { if (event.target === galleryLightbox) closeGalleryLightbox(); });
    document.addEventListener('keydown', function (event) {
      if (!galleryLightbox.classList.contains('is-open')) return;
      if (event.key === 'Escape') closeGalleryLightbox();
      if (event.key === 'ArrowLeft') showGalleryImage(galleryIndex - 1);
      if (event.key === 'ArrowRight') showGalleryImage(galleryIndex + 1);
    });
  }

  /* ---------- Variant / size buttons ---------- */
  document.querySelectorAll('.size-btn').forEach(function (b) {
    b.addEventListener('click', function () {
      var group = b.closest('.option-group');
      group.querySelectorAll('.size-btn').forEach(function (x) { x.classList.remove('selected'); });
      b.classList.add('selected');
      var labelSpan = group.querySelector('h5 span');
      if (labelSpan) labelSpan.textContent = b.textContent;
      var variantInput = document.getElementById('variantOptionInput');
      if (variantInput) variantInput.value = b.dataset.variantId || '';
      updateSelectedVariant();
    });
  });

  function updateSelectedVariant () {
    // Theme-editor / Liquid variant-picker form already syncs the hidden
    // variant id input (see snippets/product-form.liquid). This hook is
    // left in place for custom variant-matching logic if needed.
  }

  /* ---------- Accordion ---------- */
  document.querySelectorAll('.accordion-head').forEach(function (h) {
    h.addEventListener('click', function () {
      h.nextElementSibling.classList.toggle('open');
    });
  });


  var searchInput = document.getElementById('siteSearchInput');
  var searchIcon = document.getElementById('siteSearchIcon');
  var mobileSearchButton = document.getElementById('mobileSearchBtn');
  var predictivePanel = document.getElementById('predictiveSearch');
  var predictiveBackdrop = document.getElementById('predictiveSearchBackdrop');
  var predictiveInput = document.getElementById('predictiveSearchInput');
  var predictiveClose = document.getElementById('predictiveSearchClose');
  var predictiveResults = document.getElementById('predictiveSearchResults');
  var predictiveSuggestions = document.getElementById('predictiveSearchSuggestions');
  var predictiveChips = document.getElementById('predictiveSearchChips');
  var predictiveAll = document.getElementById('predictiveSearchAll');
  var predictiveTimer;
  var predictiveController;
  var predictiveLastFocus;
  var predictiveSuppressOpen = false;

  function predictiveEscape(value) {
    var element = document.createElement('div');
    element.textContent = value || '';
    return element.innerHTML;
  }

  function predictiveSearchUrl(query) {
    return window.theme.routes.search + '?q=' + encodeURIComponent(query) + '&type=product';
  }

  function openPredictiveSearch() {
    if (predictiveSuppressOpen || !predictivePanel) return;
    predictiveLastFocus = document.activeElement;
    predictivePanel.hidden = false;
    predictiveBackdrop.hidden = false;
    document.documentElement.classList.add('predictive-search-open');
    if (searchInput) searchInput.setAttribute('aria-expanded', 'true');
    if (mobileSearchButton) mobileSearchButton.setAttribute('aria-expanded', 'true');
    if (searchInput && searchInput.value && !predictiveInput.value) predictiveInput.value = searchInput.value;
    predictiveInput.focus();
    if (predictiveInput.value.trim()) loadPredictiveResults(predictiveInput.value.trim());
  }

  function closePredictiveSearch() {
    if (!predictivePanel) return;
    predictivePanel.hidden = true;
    predictiveBackdrop.hidden = true;
    document.documentElement.classList.remove('predictive-search-open');
    if (searchInput) searchInput.setAttribute('aria-expanded', 'false');
    if (mobileSearchButton) mobileSearchButton.setAttribute('aria-expanded', 'false');
    if (predictiveController) predictiveController.abort();
    predictiveSuppressOpen = true;
    if (predictiveLastFocus) predictiveLastFocus.focus();
    window.setTimeout(function () { predictiveSuppressOpen = false; }, 0);
  }

  function renderPredictiveResults(data, query) {
    var resources = data.resources && data.resources.results ? data.resources.results : {};
    var products = resources.products || [];
    var queries = resources.queries || [];
    var collections = resources.collections || [];
    var suggestions = queries.concat(collections).slice(0, 6);
    predictiveChips.innerHTML = suggestions.map(function (item) {
      var text = item.text || item.title || '';
      var url = item.url || predictiveSearchUrl(text);
      return '<a class="predictive-search-chip" href="' + predictiveEscape(url) + '">' + predictiveEscape(text) + '</a>';
    }).join('');
    predictiveSuggestions.hidden = suggestions.length === 0;
    if (!products.length) {
      predictiveResults.innerHTML = '<p class="predictive-search-message">No matching products found.</p>';
    } else {
      predictiveResults.innerHTML = products.map(function (product) {
        var image = typeof product.image === 'string' ? product.image : (product.image && product.image.url ? product.image.url : ''); if (image) image += (image.indexOf('?') === -1 ? '?' : '&') + 'width=184';
        var price = product.price ? '£' + product.price : '';
        return '<a class="predictive-search-item" role="option" href="' + predictiveEscape(product.url) + '">' + (image ? '<img src="' + predictiveEscape(image) + '" alt="" width="92" height="92">' : '<span></span>') + '<span><strong>' + predictiveEscape(product.title) + '</strong>' + (price ? '<span>' + predictiveEscape(price) + '</span>' : '') + '</span></a>';
      }).join('');
    }
    predictiveAll.href = predictiveSearchUrl(query);
    predictiveAll.hidden = false;
  }

  function loadPredictiveResults(query) {
    if (!query) {
      predictiveResults.innerHTML = '<p class="predictive-search-message">Start typing to find products.</p>';
      predictiveSuggestions.hidden = true;
      predictiveAll.hidden = true;
      return;
    }
    if (predictiveController) predictiveController.abort();
    predictiveController = new AbortController();
    predictiveResults.innerHTML = '<p class="predictive-search-message">Searching...</p>';
    var endpoint = window.theme.routes.search + '/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,query,collection&resources[limit]=8&resources[options][unavailable_products]=show';
    fetch(endpoint, { signal: predictiveController.signal })
      .then(function (response) { if (!response.ok) throw new Error('Search failed'); return response.json(); })
      .then(function (data) { renderPredictiveResults(data, query); })
      .catch(function (error) { if (error.name !== 'AbortError') predictiveResults.innerHTML = '<p class="predictive-search-message">Search is temporarily unavailable. Press Enter to view all results.</p>'; });
  }

  function runSearch() {
    var source = predictivePanel && !predictivePanel.hidden ? predictiveInput : searchInput;
    var query = source && source.value.trim();
    if (query) window.location.href = predictiveSearchUrl(query);
  }

  if (searchInput) searchInput.addEventListener('focus', openPredictiveSearch);
  if (searchInput) searchInput.addEventListener('click', openPredictiveSearch);
  if (searchIcon) searchIcon.addEventListener('click', openPredictiveSearch);
  if (mobileSearchButton) mobileSearchButton.addEventListener('click', openPredictiveSearch);
  document.addEventListener('click', function (event) {
    if (event.target.closest('#predictiveSearchClose')) closePredictiveSearch();
    if (event.target === predictiveBackdrop) closePredictiveSearch();
  });
  if (predictiveInput) predictiveInput.addEventListener('input', function () {
    clearTimeout(predictiveTimer);
    var query = predictiveInput.value.trim();
    if (searchInput) searchInput.value = predictiveInput.value;
    predictiveTimer = setTimeout(function () { loadPredictiveResults(query); }, 250);
  });
  if (predictiveInput) predictiveInput.addEventListener('keydown', function (event) { if (event.key === 'Enter') { event.preventDefault(); runSearch(); } });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && predictivePanel && !predictivePanel.hidden) closePredictiveSearch(); });

  /* ---------- Add to cart (AJAX Cart API) ---------- */
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var addOn = window.__customAddOn || 0;
      if (addOn !== 0) {
        formData.append('properties[Customisation Add-on]', (addOn > 0 ? '+' : '') + '£' + addOn.toFixed(2));
      }
      var customText = document.getElementById('customText');
      if (customText && customText.value) {
        formData.append('properties[Custom Text]', customText.value);
      }
      var submitBtn = form.querySelector('.btn-add-cart, [type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) submitBtn.textContent = 'Adding...';

      fetch(window.theme.routes.cartAdd, {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          window.location.href = window.theme.routes.cart;
        })
        .catch(function () {
          if (submitBtn) submitBtn.textContent = originalText;
          alert('Something went wrong adding this to your cart. Please try again.');
        });
    });
  });

  /* Buy It Now — add to cart then go straight to checkout */
  document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = document.querySelector('form[data-product-form]');
      if (!form) return;
      var formData = new FormData(form);
      fetch(window.theme.routes.cartAdd, {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      }).then(function () {
        window.location.href = window.theme.routes.checkout;
      });
    });
  });

  /* ---------- Cart quantity +/- (cart page, AJAX) ---------- */
  document.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input[name="updates[]"]');
      if (!input) return;
      var val = parseInt(input.value || '1', 10);
      val = btn.hasAttribute('data-qty-plus') ? val + 1 : Math.max(0, val - 1);
      input.value = val;
      var line = btn.closest('[data-line]').dataset.line;
      fetch(window.theme.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: val })
      }).then(function () { window.location.reload(); });
    });
  });

  /* ---------- Product cards → product page ---------- */
  document.querySelectorAll('.prod-card[data-href]').forEach(function (card) {
    card.addEventListener('click', function (e) {
      if (e.target.closest('.prod-wishlist')) return;
      window.location.href = card.dataset.href;
    });
  });

  /* ---------- AI Chat Widget ---------- */
  var chatBtn = document.getElementById('aiChatBtn');
  var chatPanel = document.getElementById('aiChatPanel');
  if (chatBtn && chatPanel) {
    chatBtn.addEventListener('click', function () { chatPanel.classList.toggle('open'); });
    var closeBtn = document.getElementById('aiChatClose');
    if (closeBtn) closeBtn.addEventListener('click', function () { chatPanel.classList.remove('open'); });

    var responses = [
      { keys: ['ship', 'worldwide', 'deliver', 'country'], reply: "Yes — we ship worldwide. UK standard delivery is free on all orders, and UK express delivery costs £14.99." },
      { keys: ['size', 'sizing', 'fit'], reply: "Boxing gloves run 8oz–16oz. Apparel runs XS–9XL. Check the size guide for details." },
      { keys: ['bulk', 'wholesale', 'moq'], reply: "We do bulk and wholesale orders from 25 units, with discounts up to 35% off retail. Visit our Bulk Orders page." },
      { keys: ['return', 'refund', 'exchange'], reply: "Eligible unused items can be returned within 30 days. Customers pay return postage for change-of-mind or non-faulty returns. Customised items are excluded unless faulty or incorrectly supplied." },
      { keys: ['custom', 'personalis', 'personaliz'], reply: "Many products support customisation — printing, colours, and your own artwork. Look for the 'Customise' toggle on the product page." },
      { keys: ['track', 'order status'], reply: "Once your order ships, you'll get a tracking link by email." },
      { keys: ['brand new', 'quality'], reply: "All our stock is 100% brand new and quality-checked before dispatch." }
    ];

    function addMsg (text, who) {
      var body = document.getElementById('aiChatBody');
      var div = document.createElement('div');
      div.className = 'ai-msg ' + who;
      div.textContent = text;
      body.appendChild(div);
      body.scrollTop = body.scrollHeight;
    }
    function respond (text) {
      var lower = text.toLowerCase();
      var match = responses.find(function (r) { return r.keys.some(function (k) { return lower.indexOf(k) !== -1; }); });
      setTimeout(function () {
        addMsg(match ? match.reply : "Thanks for your question! Try asking about shipping, sizing, bulk orders, customisation, or returns.", 'bot');
      }, 500);
    }
    var chatInput = document.getElementById('aiChatInput');
    var chatSend = document.getElementById('aiChatSend');
    function handleSend () {
      var text = chatInput.value.trim();
      if (!text) return;
      addMsg(text, 'user');
      chatInput.value = '';
      respond(text);
    }
    if (chatSend) chatSend.addEventListener('click', handleSend);
    if (chatInput) chatInput.addEventListener('keypress', function (e) { if (e.key === 'Enter') handleSend(); });
    document.querySelectorAll('.ai-suggest-chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        addMsg(chip.dataset.q, 'user');
        respond(chip.dataset.q);
      });
    });
  }

  /* ---------- Cookie banner ---------- */
  var cookieBanner = document.getElementById('cookieBanner');
  if (cookieBanner) {
    if (!localStorage.getItem('bsi_cookie_consent')) {
      cookieBanner.classList.add('show');
    }
    var acceptBtn = document.getElementById('cookieAccept');
    var rejectBtn = document.getElementById('cookieReject');
    if (acceptBtn) acceptBtn.addEventListener('click', function () {
      localStorage.setItem('bsi_cookie_consent', 'all');
      cookieBanner.classList.remove('show');
    });
    if (rejectBtn) rejectBtn.addEventListener('click', function () {
      localStorage.setItem('bsi_cookie_consent', 'essential');
      cookieBanner.classList.remove('show');
    });
  }

});
